module.exports = __webpack_public_path__ + "img/6d185d0.png";